import { Component, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { User } from '../shared/user.model';
import {UserService} from '../shared/user.service';

@Component({
    selector: 'user-list',
    templateUrl: 'user-list.component.html'
})
export class UsersComponent {
    columns = ['name', 'role', 'activeCount', 'overdueCount', 'actions', 'new'];
    @ViewChild('table') table: MatTable<any>;

    constructor(public userService: UserService) {}
    ngAfterViewInit() {
        this.userService.usersAdded.subscribe(users => {
            if( this.table ) {
                this.table.renderRows();  
            }
        });
    }
}